import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  align-items: flex-start;
  justify-content: flex-start;
  padding: ${theme.gutterUnit}px ${2 * theme.gutterUnit}px;
  padding-bottom: 0;
`

export default class SidebarSectionHeader extends PureComponent {
  render () {
    return (
      <Container style={{ height: this.props.height }}>
        <Text bold size='m' primary>{this.props.title}</Text>
      </Container>
    )
  }
}
